var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 31.25v-12.5a2.5 2.5 0 012.5-2.5h20a2.5 2.5 0 012.5 2.5v12.5a2.5 2.5 0 01-2.5 2.5H15a2.5 2.5 0 01-2.5-2.5z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17l13 9 13-9",
    stroke: "currentColor",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default __webpack_public_path__ + "329deef77d213d16d80e3fec172452f0.svg";
export { SvgEmailCircle as ReactComponent };